import Choices from 'choices.js';

export default new class Select {
  constructor() {
    this.selectSelector = 'select';
    this.selectNoBorderSelector = 'select_no-border';
    this.mediaQueryString = '(min-width: 769px)';

    this.isInit = false;
    this.customEventType = 'input';

    this.handler();
  }

  handler() {
    document.addEventListener('DOMContentLoaded', () => {
      this.checkSelect();
    });

    window.addEventListener('resize', () => {
      if (this.isDesktop() && !this.isInit) {
        this.checkSelect();
      }
    });
  }

  isDesktop() {
    return window.matchMedia(this.mediaQueryString).matches;
  }

  checkSelect() {
    const select = document.querySelectorAll(`.${this.selectSelector}`);

    if (!select) return;

    [...select].forEach(el => this.init(el));
  }

  init(el) {
    if (!this.isDesktop()) return;

    const border = el.classList.contains(this.selectNoBorderSelector) ? '_no-border' : '';



    el.addEventListener('choice', () => {
      el.dispatchEvent(this.createCustomEvent());
    });
  }

  createCustomEvent() {
    const inputEvent = new Event(this.customEventType, { bubbles: true, cancelable: false });

    return inputEvent;
  }
}();
